import { ApiService } from '../api.service';
import { CommonService } from '../common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { appRenameFixed } from '../appRenameFixed';
import { AbilityConfig } from '../ability-config/ability-config';
import { PlatformLocation } from '@angular/common';
var LearningPathComponent = (function () {
    function LearningPathComponent(apiService, commonService, platformLocation, route, router) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.platformLocation = platformLocation;
        this.route = route;
        this.router = router;
        this.isTencent = false; //是否是腾讯对接
        this.isShowUpdateMessage = false;
        this.appRename = new appRenameFixed();
        // companyUrl:string = "";
        this.companyLogo = '';
        this.isShowTip = false; //是否显示提示
        this.isShowBack = false; //url里是否带有isShowBack
        this.isShowToast = false; //是否显示toast
        this.isShowQuestionnaire = false; //是否显示问卷
        this.isShowIntroduction = false; //是否显示能力说明
        this.isShowBar = false; //是否显示进度条
        this.questionnaireInfo = null; //问卷信息
        this.assetsRoute = '../../assets';
        this.results = []; //学习收获
        this.progress = 0; //进度
        this.abilityStatus = 0; //是否完成
        this.canShow = false;
        this.isLocked = true; //强制锁定
        this.isPC = false;
        this.promptText = '学之有序，请先完成前面的练习'; // 提示文字
        this.courseLockState = null; //测学练考锁住状态
        this.isOnlyLearningPathCannotBack = false;
        this.isHarmonyOS = false;
        this.progressBarTheme = {
            'name': 'learn',
            'haveTitle': true,
            'color': 'rgb(105,136,238)',
            'radius': '0.2rem'
        }; //主题
        this.circleTheme = {
            'width': 280,
            'height': 280,
            'x': 0,
            'y': 0,
            'radius': 90,
            'innerRadius': 20,
            'startAngle': 0,
            'endAngle': 360,
            'angleRadian': 275,
            'colors': ['#7E9FFB', '#5F81DB', '#60B68A', '#44976C', '#EEE'] //环形颜色
        }; //主题
        this.desText = '由于升级系统，你需要重新完成<font color="#FFE258">能力诊断</font>，原本学习的数据已被<font color="#FFE258">保留</font>。';
        this.flag = false;
        this.showBackBtn = false; //从LMS平台隐藏按钮
    }
    LearningPathComponent.prototype.ngOnInit = function () {
        var _this = this;
        // ---Stephen add 2025-03-07---
        // 添加是否腾讯对接的判断
        var isHaveBackurl = this.platformLocation['location']['href'].indexOf('backurl') === -1;
        if (!isHaveBackurl) {
            window.sessionStorage.removeItem('txModuleId');
        }
        this.isTencent = this.commonService.checkAndSetModuleId();
        console.log(this.isTencent, '🍜🍜🍜🍜🍜🍜');
        // -------------------------------------------------------------------
        this.isHarmonyOS = this.commonService.isHarmonyOS();
        this.commonService.setStorage('moduleId', '0');
        var self = this;
        var herfUrl = this.platformLocation['location']['origin'];
        // if(herfUrl === 'https://m-dev.transtalent.cn' || herfUrl === 'http://localhost:4200'){
        self.sub = self.route.params.subscribe(function (params) {
            self.learningPathMetaId = params['learningPathMetaId'];
        });
        // ---Stephen add 2025-03-07---
        // 后端不方便拼接情景模拟url，统一跳转到learningpath，前端统一跳转情景模拟
        if (this.isTencent) {
            this.tencentProcess(this.learningPathMetaId);
            return;
        }
        // -------------------------------------------------------------------
        if (this.learningPathMetaId == 202) {
            this.commonService.getOnceIno(1022).then(function (result) {
                _this.isShowUpdateMessage = result !== 1;
            });
        }
        if (localStorage.getItem('source_env') === 'LMS_SCORM') {
            this.showBackBtn = true;
        }
        if (!this.commonService.getStorage('skuId')) {
            self.getTicketIsExpire(self.learningPathMetaId).then(function (res) {
                if (res.isUserTicketExpiry) {
                    self.router.navigate(['learning-map']);
                }
                else {
                    self.normalProcess();
                }
            });
        }
        else {
            self.normalProcess();
        }
    };
    /**
     * 处理腾讯课堂学习路径的特定逻辑
     * @param {any} learningPathMetaId 学习路径的元ID，用于识别特定的学习路径
     */
    LearningPathComponent.prototype.tencentProcess = function (learningPathMetaId) {
        var _this = this;
        var that = this;
        // 初始化能力配置对象，用于后续的能力相关操作
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        this.getOrCreateLearningPath(this.learningPathMetaId).then(function (res) {
            that.userId = res.userId;
            $('#userIdContainer').val(that.userId);
            that.learningPathId = res.id;
            that.abilityStatus = res.status;
        }).then(function () {
            // 获取学习路径子项
            _this.getLearningPathSubItems(learningPathMetaId).then(function (result) {
                that.learningPath = result;
                // 查找第一个 type === 3 的子项
                var practiceItem = that.learningPath.subItems.find(function (item, index) { return item.type === 3; });
                var practiceMetaId = practiceItem.practiceMetaId;
                var practiceIndex = practiceItem ? that.learningPath.subItems.indexOf(practiceItem) + 1 : null;
                // 根据 learningPathMetaId 判断跳转逻辑
                if ([402, 302].includes(learningPathMetaId)) {
                    // 特殊路径跳转
                    that.router.navigate(['egret-practice-communicate', learningPathMetaId * 100 + 1], { queryParams: { moduleId: window.sessionStorage.getItem('txModuleId') } });
                }
                else {
                    // 情景列表跳转
                    var link = that.abilityConfig.getPracticeLinkList(that.learningPath.name, that.learningPathId, practiceMetaId);
                    if (link.length > 0) {
                        console.log('我跳转了');
                        that.router.navigate(link, { queryParams: { moduleId: window.sessionStorage.getItem('txModuleId') } });
                    }
                }
            });
        });
    };
    // 正常执行的流程
    LearningPathComponent.prototype.normalProcess = function () {
        var _this = this;
        this.status = 1;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.isShowBack = this.platformLocation['location']['href'].indexOf('isShowBack') !== -1;
        this.isOnlyLearningPathCannotBack = this.commonService.getStorage('isOnlyLearningPathCannotBack') ? true : this.platformLocation['location']['href'].indexOf('onlyLearningPathCannotBack') !== -1;
        if (this.isOnlyLearningPathCannotBack) {
            this.commonService.setStorage('isOnlyLearningPathCannotBack', '1');
        }
        this.isShowBackBtn();
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        if (this.platformLocation['location']['href'].split('backurl=')[1]) {
            this.commonService.setStorage('backurl', this.platformLocation['location']['href'].split('backurl=')[1]);
            document.cookie = 'backUrl=' + this.platformLocation['location']['href'].split('backurl=')[1];
        }
        this.customerBackUrl = this.commonService.getCookie('backUrl') ? decodeURIComponent(this.commonService.getCookie('backUrl')) : null;
        window.sessionStorage.removeItem('newEdition');
        // this.getThirdCompany();
        this.mengban = false;
        this.sub = this.route.params.subscribe(function (params) {
            _this.learningPathMetaId = params['learningPathMetaId'];
            console.log(params, _this.learningPathMetaId, 555555);
            $('#learningPathMetaIdContainer').val(_this.learningPathMetaId);
            _this.commonService.setStorage('learningPathMetaId', String(_this.learningPathMetaId));
            _this.onceValue = _this.commonService.getOnceValue(_this.learningPathMetaId, 9);
        });
        this.route.queryParams.subscribe(function (queryParams) {
            _this.firstDay = !!queryParams['firstDay'];
            _this.isLastDay = !!queryParams['isLastDay'];
        });
        this.commonService.removeStorage('projectmsg');
        this.projectId = this.commonService.getStorage('projectId');
        //开始记录各能力学习时长
        // this.commonService.setStorage("learningPathMetaId",this.learningPathMetaId + "");
        // this.commonService.setStorage("learningPathMetaId-moduleId","-1");
        this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/exposeoutapi/setAbilitySession/' + this.learningPathMetaId + '/-1'
        }).subscribe(function (result) { });
        this.results = this.setAssetsResults(this.learningPathMetaId);
        this.getOrCreateLearningPath(this.learningPathMetaId).then(function (result) {
            console.log(result);
            _this.userId = result.userId;
            $('#userIdContainer').val(_this.userId);
            _this.learningPathId = result.id;
            _this.abilityStatus = result.status;
        }).then(function () {
            return _this.commonService.getOnceIno(_this.onceValue).then(function (result) {
                return _this.isShowIntroduction = !(result === 1 || _this.commonService.getStorage('skuId') && result === 1);
            });
        }).then(function () {
            return _this.getLearningPathSubItems(_this.learningPathMetaId).then(function (result) {
                console.log(result);
                return _this.learningPath = result;
            });
        }).then(function () {
            return _this.getUserQuestionnaireInfo(_this.learningPathMetaId).then(function (result) {
                return _this.questionnaireInfo = result;
            });
        }).then(function () {
            return _this.getUserInfo().then(function (result) {
                return _this.user = result;
            });
        }).then(function () {
            if (_this.projectId) {
                return _this.getCourseitemsLock(_this.learningPathMetaId).then(function (result) {
                    return _this.courseLockState = result;
                });
            }
        }).then(function () {
            if (!_this.commonService.getStorage('campId')) {
                return _this.getAbilityHomework(Number(_this.projectId), _this.learningPathMetaId).then(function (result) {
                    return _this.homeworkList = result;
                });
            }
        }).then(function () {
            var id = _this.homeworkList && _this.homeworkList.length > 0 ? _this.projectId : -1;
            return _this.getUserQueryLearningProgress(_this.learningPathMetaId, id).then(function (result) {
                return _this.progressLists = result;
            });
        }).then(function () {
            if (_this.isShowIntroduction) {
                _this.apiService.learingTime({ learningPathMetaId: _this.learningPathMetaId, module: _this.learningPath.name, courseUnit: '', type: 1, btnName: '课程介绍页', userId: _this.commonService.getStorage('userId') }).subscribe(function (result) {
                    console.log(result);
                });
                // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入能力介绍页','userId':this.userId}).then();
            }
            _this.commonService.setCustomLockDate(_this.learningPath, Date());
            _this.commonService.setStorage('companiesType', _this.user);
            if (_this.learningPathMetaId == 18 || _this.learningPathMetaId == 30 || _this.learningPathMetaId == 12 || _this.learningPathMetaId == 26 || _this.learningPathMetaId == 404) {
                _this.isShowBar = true;
                _this.canShow = true;
            }
            else {
                _this.isShowBar = !_this.isShowIntroduction;
                _this.canShow = !_this.isShowIntroduction;
            }
            _this.progressLists = _this.progressLists[_this.getIndexByConditionIdInLists(_this.progressLists, 'userId', _this.userId)];
            _this.learningPath.currentItemIndex = _this.progressLists.progressList[0].currentItemIndex;
            _this.progress = _this.progressLists.progressList[0].progress;
            //向LMS平台传递数据
            if (localStorage.getItem('source_env') === 'LMS_SCORM') {
                _this.sendProgressToLMS(_this.progress);
                _this.sendStatusToLMS(_this.progress);
            }
            console.log(_this.progress, 'this.progress');
            var arr = _this.setSubItemsInfo(_this.learningPathMetaId);
            for (var i = 0, len = _this.learningPath.subItems.length; i < len; i += 1) {
                if (arr[i]) {
                    _this.learningPath.subItems[i].desc = arr[i][0];
                    _this.learningPath.subItems[i].time = arr[i][1];
                }
                else {
                    _this.learningPath.subItems[i].desc = '';
                    _this.learningPath.subItems[i].time = '';
                }
            }
            _this.mode = _this.learningPath.subItems.length > 3 ? 1 : 2;
            if (_this.projectId) {
                var self_1 = _this;
                self_1.learningPath.subItems.forEach(function (item) {
                    self_1.courseLockState.forEach(function (itm) {
                        if (item.type == itm.type) {
                            var openAt = itm.openAt;
                            itm.openTime = openAt ? self_1.tansFromTimestamp(openAt, 1) : '';
                            itm.promptTime = openAt ? self_1.tansFromTimestamp(openAt, 2) : '';
                            item.courseLockdata = itm;
                        }
                    });
                });
                _this.commonService.setStorage('projectmsg', JSON.stringify(self_1.courseLockState));
            }
            //满意度调查显示逻辑
            //获取到用户相应能力满意度 （questionnaireInfo长度为0 || questionnaireInfo长度大于0 && isShow不等于1） &&情景模拟完成了 && 后测没有完成
            // this.isShowQuestionnaire = this.questionnaireInfo && (this.questionnaireInfo.length ===0 || (this.questionnaireInfo.length > 0 && this.questionnaireInfo.filter(d=>d.star === -1).length > 0)) && this.learningPath.subItems[this.getModuleIndex(4)].progress !==100 && this.learningPath.subItems[this.getModuleIndex(3)].progress ===100 ? true : false;
            _this.isShowQuestionnaire = _this.questionnaireInfo && (_this.questionnaireInfo.length === 0 || (_this.questionnaireInfo.length > 0 && _this.questionnaireInfo.filter(function (d) { return d.star === -1; }).length > 0)) && _this.abilityStatus === 1 && _this.learningPath.currentItemIndex === 4;
            // 无后测版本逻辑
            // 是2019年6月18日以前注册的用户并且能力诊断未完成并且是之前完成过改课程的用户显示提示框
            // this.isShowTip = this.compareDate("2019-06-18", this.user.createdAt.split('T')[0]) && this.learningPath.subItems[this.getModuleIndex(1)].progress !==100 && this.learningPath.subItems[this.getModuleIndex(2)].progress > 0 ? true : false;
            //团队训练营新逻辑
            if (_this.commonService.getStorage('campId') && _this.commonService.getStorage('projectId') && _this.commonService.getStorage('skuId')) {
                _this.canShow = false;
                _this.showCampCourse();
            }
            else if (_this.commonService.getStorage('campId') && !_this.commonService.getStorage('projectId') && _this.commonService.getStorage('skuId')) {
                _this.canShow = false;
                _this.showCampCourse();
            }
            else if (!_this.commonService.getStorage('campId') && _this.commonService.getStorage('projectId') && !_this.commonService.getStorage('skuId')) {
                _this.canShow = true;
            }
            else {
                _this.canShow = true;
            }
        });
    };
    //发送状态给LMS平台
    LearningPathComponent.prototype.sendStatusToLMS = function (progress) {
        //子页面向父页面发送消息
        var statusData = {
            'type': 'LMS_LEARN_COMPLETED',
            'data': Number(progress) === 100
        };
        window.parent.postMessage(statusData, '*');
    };
    //发送进度给LMS平台
    LearningPathComponent.prototype.sendProgressToLMS = function (progress) {
        //子页面向父页面发送消息
        var progressData = {
            'type': 'LMS_LEARN_PROGRESS',
            'data': progress
        };
        console.log(progressData, 'progressData');
        window.parent.postMessage(progressData, '*');
    };
    // 时间转化
    LearningPathComponent.prototype.tansFromTimestamp = function (timestamp, type) {
        var date = new Date(timestamp);
        var Y = date.getFullYear();
        var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
        var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        if (type == 1) {
            return M + "." + D;
        }
        else if (type == 2) {
            return Y + "-" + M + "-" + D + " " + h + ":" + m;
        }
        else if (type == 3) {
            return M + "/" + D;
        }
    };
    //0启程 1辅导 2团队 11授权 12沟通 13组织 14协作 15影响力 16决策 18启程 20变革 22增强版影响力 24MAX 26TS 28冲突 30专业版影响力 201目标选才
    //402沟通 403授权 404领导力启程 405辅导 406 MAX 607影响力专业版
    LearningPathComponent.prototype.setAssetsResults = function (learningPathMetaId) {
        return {
            1: ['工作结果出色，省心省力', '强将无弱兵，团队实力大增', '管理实力水涨船高'],
            205: ['工作结果出色，省心省力', '强将无弱兵，团队实力大增', '管理实力水涨船高'],
            305: ['工作结果出色，省心省力', '强将无弱兵，团队实力大增', '管理实力水涨船高'],
            405: ['工作结果出色，省心省力', '强将无弱兵，团队实力大增', '管理实力水涨船高'],
            605: ['工作结果出色，省心省力', '强将无弱兵，团队实力大增', '管理实力水涨船高'],
            2: ['成为团队引路人', '找到团队问题的症结', '让团队更有凝聚力'],
            11: ['摆脱琐事，聚焦团队重点', '腾出时间，挑战更高的职涯目标', '培养良将，帮助下属发展'],
            403: ['摆脱琐事，聚焦团队重点', '腾出时间，挑战更高的职涯目标', '培养良将，帮助下属发展'],
            12: ['掌控沟通流程，提高互动效率', '辨识互动中的“情绪需求”', '提升互动沟通技巧'],
            402: ['掌控沟通流程，提高互动效率', '辨识互动中的“情绪需求”', '提升互动沟通技巧'],
            302: ['掌控沟通流程，提高互动效率', '辨识互动中的“情绪需求”', '提升互动沟通技巧'],
            13: ['工作状态从容不迫', '工作安排井井有条', '团队管理忙而不乱'],
            14: ['完成既定目标任务', '成为内外部可信赖的伙伴', '建立长久的人脉关系'],
            15: ['向上管理，获得上级认可', '影响他人，见招拆招', '赢得承诺，有效推进工作'],
            607: ['向上管理，获得上级认可', '影响他人，见招拆招', '赢得承诺，有效推进工作'],
            16: ['掌握有效的决策路径', '规避阻碍决策的高危陷阱', '成为高质量的决策者'],
            18: ['领导者的思维模式', '领导者应有的自我修养', '了解领导者的必备能力'],
            404: ['领导者的思维模式', '领导者应有的自我修养', '了解领导者的必备能力'],
            20: ['良好心态，应对工作中的变化', '成为受上级青睐的“开拓者”', '轻松带领团队，不惧外部风浪'],
            24: ['点亮绩效管理技能', '有效掌控绩效谈话', '帮助团队达至最佳绩效'],
            406: ['点亮绩效管理技能', '有效掌控绩效谈话', '帮助团队达至最佳绩效'],
            606: ['点亮绩效管理技能', '有效掌控绩效谈话', '帮助团队达至最佳绩效'],
            26: ['掌握识人标准', '提升面谈技巧', '快速辨识最佳候选人'],
            28: ['帮助矛盾双方达成一致', '及时避免冲突升级', '应对冲突，游刃有余'],
            30: ['向上管理，获得上级认可', '影响他人，见招拆招', '赢得承诺，有效推进工作'],
        }[Number(learningPathMetaId)] || [];
    };
    //设置新的信息
    //1辅导 2团队 11授权 12基础版沟通 13组织 14协作 15影响力 607影响力专业版 16决策 18启程 20变革 22增强版影响力 24MAX 26TS 28冲突 30专业版影响力
    //201目标选才 202标准版沟通 402沟通 403授权 404领导力启程 405辅导 406 MAX 607影响力专业版
    LearningPathComponent.prototype.setSubItemsInfo = function (learningPathMetaId) {
        return {
            1: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：50分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            205: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：50分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            305: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：70分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            315: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：70分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            325: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：70分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            335: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：70分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            405: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：50分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            605: [['测一测，你是什么样的辅导者？', '预计时长：10分钟'], ['9个单元，找到辅导的解题思路', '预计时长：70分钟'], ['场景化的实战演练', '预计时长：60分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            2: [['带领团队，你的优势与风险？', '预计时长：10分钟'], ['9个单元，学习团队成功要素', '预计时长：45分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            11: [['了解你的授权能力现状', '预计时长：10分钟'], ['7个单元，破解授权挑战', '预计时长：30分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            403: [['了解你的授权能力现状', '预计时长：10分钟'], ['7个单元，破解授权挑战', '预计时长：30分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            12: [['10个单元，学习经典沟通技巧', '预计时长：60分钟']],
            13: [['了解你的能力优势与风险', '预计时长：10分钟'], ['6个单元，掌握计划与组织要领', '预计时长：40分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            14: [['与他人协作，你的现状如何？', '预计时长：10分钟'], ['6个单元，帮你找到协作最优解', '预计时长：40分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            15: [['了解你的影响力指数', '预计时长：10分钟'], ['6个单元，掌握影响力的知识要点', '预计时长：40分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            607: [['了解你的影响力指数', '预计时长：10分钟'], ['6个单元，掌握影响力的知识要点', '预计时长：60分钟'], ['场景化的实战演练', '预计时长：60分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            307: [['了解你的影响力指数', '预计时长：10分钟'], ['6个单元，掌握影响力的知识要点', '预计时长：55分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            317: [['了解你的影响力指数', '预计时长：10分钟'], ['6个单元，掌握影响力的知识要点', '预计时长：75分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            327: [['了解你的影响力指数', '预计时长：10分钟'], ['6个单元，掌握影响力的知识要点', '预计时长：55分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            16: [['了解你的决策现状', '预计时长：10分钟'], ['7个单元，教你如何有效决策', '预计时长：35分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            308: [['了解你的决策现状', '预计时长：10分钟'], ['7个单元，教你如何有效决策', '预计时长：55分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            318: [['了解你的决策现状', '预计时长：10分钟'], ['7个单元，教你如何有效决策', '预计时长：55分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            18: [['开启你的领导力之旅', '预计时长：25分钟']],
            404: [['开启你的领导力之旅', '预计时长：25分钟']],
            20: [['了解你的变革指数', '预计时长：10分钟'], ['7个单元，加速你的变革', '预计时长：40分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            309: [['了解你的变革指数', '预计时长：10分钟'], ['7个单元，加速你的变革', '预计时长：55分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            24: [['绩效管理，你的现状如何？ ', '预计时长：10分钟'], ['11个单元，详解绩效的全周期管理', '预计时长：100分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            406: [['绩效管理，你的现状如何？ ', '预计时长：10分钟'], ['11个单元，详解绩效的全周期管理', '预计时长：100分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            606: [['绩效管理，你的现状如何？ ', '预计时长：10分钟'], ['11个单元，详解绩效的全周期管理', '预计时长：120分钟'], ['场景化的实战演练', '预计时长：60分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            26: [['8个单元，面试技巧全知道', '预计时长：80分钟']],
            28: [['了解自己：你善于应对冲突吗？', '预计时长：10分钟'], ['5个单元， 让“冲突”不再是难题', '预计时长：40分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            30: [['了解你的影响力指数', '预计时长：10分钟'], ['6个单元，掌握影响力的知识要点', '预计时长：60分钟'], ['场景化的实战演练', '预计时长：60分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            201: [['了解你的“识人”水准', '预计时长：10分钟'], ['9个单元，面试技巧全知道', '预计时长：80分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            301: [['了解你的“识人”水准', '预计时长：10分钟'], ['9个单元，面试技巧全知道', '预计时长：100分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            311: [['了解你的“识人”水准', '预计时长：10分钟'], ['9个单元，面试技巧全知道', '预计时长：100分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            202: [['了解你的职场沟通风格', '预计时长：10分钟'], ['11个单元，学习经典沟通技巧', '预计时长：60分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            302: [['了解你的职场沟通风格', '预计时长：10分钟'], ['11个单元，学习经典沟通技巧', '预计时长：80分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            312: [['了解你的职场沟通风格', '预计时长：10分钟'], ['11个单元，学习经典沟通技巧', '预计时长：80分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            402: [['了解你的职场沟通风格', '预计时长：10分钟'], ['11个单元，学习经典沟通技巧', '预计时长：60分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            208: [['将战略执行落地，你的现状如何？', '预计时长：10分钟'], ['9个单元，了解执行力三大要领', '预计时长：50分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            209: [['激励与保留下属，你的表现如何？', '预计时长：10分钟'], ['9个单元，学会激励与保留人才', '预计时长：90分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            210: [['领导虚拟团队，你的现状如何？', '预计时长：10分钟'], ['6个单元，高效管理虚拟团队', '预计时长：90分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            211: [['发展团队成员，你的现状如何？', '预计时长：10分钟'], ['6个单元，带你解锁培养人才的3A流程 ', '预计时长：60分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            212: [['推动团队创新，你的现状如何？', '预计时长：10分钟'], ['7个单元拆解如何有效推动创新', '预计时长：70分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            304: [['与他人协作，你的现状如何？', '预计时长：10分钟'], ['6个单元，帮你找到协作最优解', '预计时长：60分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            303: [['了解你的授权能力现状', '预计时长：10分钟'], ['7个单元，破解授权挑战', '预计时长：50分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
            204: [['带领团队，你的优势与风险？', '预计时长：10分钟'], ['8个单元，学习团队六大关键行动', '预计时长：75分钟'], ['场景化的实战演练', '预计时长：20分钟'], ['是时候证明你的实力了！', '预计时长：10分钟']],
        }[learningPathMetaId] || [];
    };
    //根据条件在数组中获取下标
    LearningPathComponent.prototype.getIndexByConditionIdInLists = function (Lists, condition, value) {
        return (Lists || []).findIndex(function (v) { return v[condition] === value; });
    };
    //查询能力模块信息
    LearningPathComponent.prototype.getLearningPathSubItems = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/learningpathes/' + learningPathMetaId,
        }).toPromise();
    };
    //查询用户学习进度
    LearningPathComponent.prototype.getUserQueryLearningProgress = function (learningPathMetaId, projectId) {
        var url = projectId === -1 ? 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId) : 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId) + '&projectId=' + String(projectId);
        return this.apiService.ajax({
            'type': 'GET',
            'url': url,
        }).toPromise();
    };
    //控制测,学,练,考是否锁住
    LearningPathComponent.prototype.getCourseitemsLock = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learningpathes/itemsLock/' + String(learningPathMetaId) + '?projectId=' + this.projectId,
        }).toPromise();
    };
    //查询用户学习凭证是否过期
    LearningPathComponent.prototype.getTicketIsExpire = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/userTicket/verifyUserTicketIsExpire?learningPathMetasId=' + learningPathMetaId,
        }).toPromise();
    };
    //查询用户相应能力满意度
    LearningPathComponent.prototype.getUserQuestionnaireInfo = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
        }).toPromise();
    };
    //获取模块位于learningPathSubItem里的下标
    LearningPathComponent.prototype.getModuleIndex = function (value) {
        return this.learningPath.subItems.map(function (item) { return item.type; }).indexOf(value);
    };
    // 根据learningPathMetaId创建或者获取LearningPath
    LearningPathComponent.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learningpathes/' + learningPathMetaId
        }).toPromise();
    };
    //获取用户信息
    LearningPathComponent.prototype.getUserInfo = function () {
        return this.apiService.getUserInfo().toPromise();
    };
    // 比较日期大小
    LearningPathComponent.prototype.compareDate = function (d1, d2) {
        var constDate = new Date(d1);
        var date = new Date(d2);
        return constDate.getTime() > date.getTime();
    };
    // 关闭问卷
    LearningPathComponent.prototype.closeQuestionnaire = function () {
        this.isShowQuestionnaire = false;
    };
    /* 获取第三方公司返回 */
    LearningPathComponent.prototype.isShowBackBtn = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'GET',
            'url': 'sr/exposeoutapi/getAbilityBack'
        }).subscribe(function (result) {
            _this.abilityBack = result.data.abilityBack;
        });
    };
    LearningPathComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    LearningPathComponent.prototype.goToLearningMap = function () {
        if (this.commonService.getStorage('skuId') && !this.commonService.getStorage('onlyCamp')) {
            this.router.navigate(['learning-camp', this.commonService.getStorage('skuId'), this.commonService.getStorage('campId')]);
        }
        else if (this.commonService.getStorage('skuId') && this.commonService.getStorage('onlyCamp')) {
            this.router.navigate(['learning-camp', this.commonService.getStorage('skuId'), this.commonService.getStorage('campId'), -1]);
        }
        else if (!this.commonService.getStorage('skuId')) {
            if (this.customerBackUrl) {
                location.href = this.customerBackUrl;
            }
            else {
                if (this.projectId) {
                    this.router.navigate(['learning-project', this.projectId]);
                    return;
                }
                this.router.navigate(['learning-map']);
            }
        }
    };
    LearningPathComponent.prototype.hideTip = function () {
        $('#shade').fadeOut();
        $('#tip').fadeOut();
    };
    LearningPathComponent.prototype.hideTip2 = function () {
        $('#shade2').fadeOut();
        $('#tip2').fadeOut();
    };
    LearningPathComponent.prototype.try = function () {
        var link = ['form', '3'];
        this.router.navigate(link);
    };
    LearningPathComponent.prototype.mban = function () {
        if (this.status != 1) {
            console.log('点击');
            this.mengban = false;
        }
    };
    LearningPathComponent.prototype.shiyong = function () {
        this.mengban = false;
        var link = ['form', '3'];
        this.router.navigate(link);
    };
    LearningPathComponent.prototype.closeTip = function () {
        this.mengban = false;
    };
    LearningPathComponent.prototype.cardClick = function (i) {
        var type = this.learningPath.subItems[i].type;
        //开始记录各能力模块学习时长
        // this.commonService.setStorage("learningPathMetaId-moduleId",type + "");
        this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/exposeoutapi/setAbilitySession/' + this.learningPathMetaId + '/' + type
        }).subscribe(function (result) { });
        if (type == 0) {
            this.showVector();
        }
        else if (type == 1) {
            this.commonService.setStorage('moduleId', '1');
            this.showPreSurvey();
        }
        else if (type == 2) {
            this.showCourse();
        }
        else if (type == 3) {
            this.commonService.setStorage('moduleId', '3');
            this.showPractice();
        }
        else if (type == 4) {
            this.commonService.setStorage('moduleId', '4');
            this.showPostSurvey();
        }
    };
    LearningPathComponent.prototype.exitUpdateMessage = function () {
        this.commonService.setOnceIno(1022).subscribe();
        this.isShowUpdateMessage = false;
    };
    LearningPathComponent.prototype.showVector = function () {
        if (this.status == 4 || this.status == 3) {
            var link = ['vector', this.learningPathId];
            this.router.navigate(link);
        }
        else if (this.learningPath.currentItemIndex >= 0 && this.status == 1) {
            var link = ['vector', this.learningPathId];
            this.router.navigate(link);
        }
    };
    // 跳转前测
    LearningPathComponent.prototype.showPreSurvey = function () {
        var surveyMetaId, itemIndex;
        /* 进入新能力诊断标识 */
        var version = 0;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 1) {
                surveyMetaId = item.surveyMetaId;
                itemIndex = index + 1;
                if (item.version) {
                    version = item.version;
                }
            }
        });
        // if(this.learningPath.currentItemIndex>=itemIndex&&this.status==1){
        if ((this.learningPath.currentItemIndex >= itemIndex && !this.learningPath.subItems[0].openAt) || (this.learningPath.subItems[0].openAt && !this.learningPath.subItems[0].isLock) && this.status == 1 || (this.status == 4 || this.status == 3)) {
            if (this.learningPath.status == 0) {
                this.apiService.updateLearningPathStatus(String(this.learningPathId)).subscribe(function (result) {
                });
            }
            var link = ['survey', this.learningPathId, surveyMetaId, 1];
            //影响力转向新能力检测
            if (version == 1) {
                link = ['ability-survey', this.learningPathMetaId, 1];
            }
            this.router.navigate(link, {
                queryParams: {
                    abilityName: this.learningPath.name
                }
            });
        }
        else if (this.status == 1 && (this.learningPath.currentItemIndex < itemIndex && !this.learningPath.subItems[0].openAt) || (this.learningPath.subItems[0].openAt && this.learningPath.subItems[0].isLock)) {
            this.showToast();
        }
    };
    LearningPathComponent.prototype.showCampCourse = function () {
        var courseId, itemIndex;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 2) {
                courseId = item.id;
                itemIndex = index + 1;
            }
        });
        if (this.isLastDay) {
            this.router.navigate(['course-new', this.learningPathId, courseId], { queryParams: { isLastDay: 1 } });
        }
        else if (this.firstDay) {
            this.router.navigate(['course-new', this.learningPathId, courseId], { queryParams: { firstDay: 1 } });
        }
        else {
            if ((this.learningPath.currentItemIndex >= itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && !this.learningPath.subItems[itemIndex - 1].isLock) || this.status != 1) {
                var link = ['course-new', this.learningPathId, courseId];
                this.router.navigate(link);
            }
            else if (!this.isLastDay && this.status == 1 && (this.learningPath.currentItemIndex < itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && this.learningPath.subItems[itemIndex - 1].isLock)) {
                this.showToast();
            }
            if ((this.learningPath.currentItemIndex >= itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && !this.learningPath.subItems[itemIndex - 1].isLock) || this.status != 1) {
                var link = ['course-new', this.learningPathId, courseId];
                // this.router.navigate(link)
                if (this.firstDay) {
                    this.router.navigate(link, { queryParams: { firstDay: 1 } });
                }
                else {
                    this.router.navigate(link);
                }
            }
            else if (!this.isLastDay && this.status == 1 && (this.learningPath.currentItemIndex < itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && this.learningPath.subItems[itemIndex - 1].isLock)) {
                this.showToast();
            }
        }
    };
    // 跳转课程学习
    LearningPathComponent.prototype.showCourse = function () {
        var courseId, itemIndex, promptTxt;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 2) {
                courseId = item.id;
                itemIndex = index + 1;
                if (item.courseLockdata && item.courseLockdata.lockType == 1) {
                    promptTxt = "\u8BFE\u7A0B\u5B66\u4E60\u5C06\u4E8E" + item.courseLockdata.promptTime + "\u5F00\u653E\u3002";
                }
                else {
                    promptTxt = '学之有序，请先完成前面的练习';
                }
            }
        });
        this.promptText = promptTxt;
        if (this.status == 3 || this.status == 4) {
            var link = ['course', this.learningPathId, courseId];
            this.router.navigate(link);
        }
        else {
            if (this.projectId && this.learningPath.subItems[itemIndex - 1].courseLockdata && this.learningPath.subItems[itemIndex - 1].courseLockdata.lock) {
                this.showToast();
                return;
            }
            if ((this.learningPath.currentItemIndex >= itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && !this.learningPath.subItems[itemIndex - 1].isLock) || this.status != 1) {
                var link = ['course-new', this.learningPathId, courseId];
                // this.router.navigate(link)
                if (this.firstDay) {
                    this.router.navigate(link, { queryParams: { firstDay: 1 } });
                }
                else if (this.isLastDay) {
                    this.router.navigate(link, { queryParams: { isLastDay: 1 } });
                }
                else {
                    this.router.navigate(link);
                }
            }
            else if (this.status == 1 && (this.learningPath.currentItemIndex < itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && this.learningPath.subItems[itemIndex - 1].isLock)) {
                this.showToast();
            }
        }
    };
    LearningPathComponent.prototype.showIntroduction = function () {
        this.isShowIntroduction = true;
        this.flag = true;
    };
    // 跳转情景模拟
    LearningPathComponent.prototype.showPractice = function () {
        var practiceMetaId, practiceIndex, promptTxt;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 3) {
                practiceMetaId = item.practiceMetaId;
                practiceIndex = index + 1;
                if (item.courseLockdata && item.courseLockdata.lockType == 1) {
                    promptTxt = "\u60C5\u666F\u6A21\u62DF\u5C06\u4E8E" + item.courseLockdata.promptTime + "\u5F00\u653E\u3002";
                }
                else {
                    promptTxt = '学之有序，请先完成前面的练习';
                }
            }
        });
        this.promptText = promptTxt;
        if (this.learningPathMetaId == 607) {
            practiceMetaId = 607;
        }
        if (this.learningPathMetaId == 30) {
            practiceMetaId = 16;
        }
        if (this.learningPathMetaId == 15) {
            practiceMetaId = 9;
        }
        if (this.projectId && this.learningPath.subItems[practiceIndex - 1].courseLockdata && this.learningPath.subItems[practiceIndex - 1].courseLockdata.lock) {
            this.showToast();
            return;
        }
        if ((this.learningPath.currentItemIndex >= practiceIndex && !this.learningPath.subItems[practiceIndex - 1].openAt) || (this.learningPath.subItems[practiceIndex - 1].openAt && !this.learningPath.subItems[practiceIndex - 1].isLock) || this.status != 1) {
            if (this.learningPathMetaId == 402 || this.learningPathMetaId == 302) {
                this.router.navigate(['egret-practice-communicate', this.learningPathMetaId * 100 + 1]);
            }
            else {
                //转向情景列表
                console.log(this.learningPath.name, this.learningPathId);
                var link = this.abilityConfig.getPracticeLinkList(this.learningPath.name, this.learningPathId, practiceMetaId);
                if (link.length > 0) {
                    console.log('我跳转了');
                    this.router.navigate(link);
                }
            }
        }
        else if (this.status == 1 && (this.learningPath.currentItemIndex < practiceIndex && !this.learningPath.subItems[practiceIndex - 1].openAt) || (this.learningPath.subItems[practiceIndex - 1].openAt && this.learningPath.subItems[practiceIndex - 1].isLock)) {
            this.showToast();
        }
    };
    // 跳转后测
    LearningPathComponent.prototype.showPostSurvey = function () {
        var surveyMetaId, itemIndex, promptTxt;
        /* 进入新能力诊断标识 */
        var version = 0;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 4) {
                surveyMetaId = item.surveyMetaId;
                itemIndex = index + 1;
                if (item.version) {
                    version = item.version;
                }
                if (item.courseLockdata && item.courseLockdata.lockType == 1) {
                    promptTxt = "\u80FD\u529B\u8003\u6838\u5C06\u4E8E" + item.courseLockdata.promptTime + "\u5F00\u653E\u3002";
                }
                else {
                    promptTxt = '学之有序，请先完成前面的练习';
                }
            }
        });
        this.promptText = promptTxt;
        if (Number(this.learningPathMetaId) === 302) {
            this.router.navigate(['ability-survey', this.learningPathMetaId, 2]).then();
            return;
        }
        if (this.projectId && this.learningPath.subItems[itemIndex - 1].courseLockdata && this.learningPath.subItems[itemIndex - 1].courseLockdata.lock) {
            this.showToast();
            return;
        }
        if ((this.learningPath.currentItemIndex >= itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && !this.learningPath.subItems[itemIndex - 1].isLock) && this.status == 1) {
            var link = ['survey', this.learningPathId, surveyMetaId, 1];
            //影响力转向新能力检测
            if (version == 1) {
                link = ['ability-survey', this.learningPathMetaId, 2];
            }
            this.router.navigate(link);
        }
        else if (this.status == 1 && (this.learningPath.currentItemIndex < itemIndex && !this.learningPath.subItems[itemIndex - 1].openAt) || (this.learningPath.subItems[itemIndex - 1].openAt && this.learningPath.subItems[itemIndex - 1].isLock)) {
            console.log(this.learningPathMetaId, 2783947923478923);
            this.showToast();
        }
    };
    LearningPathComponent.prototype.showToast = function () {
        var _this = this;
        this.isShowToast = true;
        setTimeout(function () {
            _this.isShowToast = false;
        }, 2000);
    };
    LearningPathComponent.prototype.exitTip = function () {
        this.isShowTip = false;
    };
    LearningPathComponent.prototype.closeLearningPathIntroduction = function () {
        this.isShowIntroduction = false;
        this.isShowBar = true;
        this.canShow = true;
        // setTimeout(()=>{
        //   this.isShowBar = true;
        // },500);
        if (!this.flag) {
            this.apiService.learingTime({ learningPathMetaId: this.learningPathMetaId, module: this.learningPath.name, courseUnit: '', type: 2, btnName: '课程介绍页', userId: this.commonService.getStorage('userId') }).subscribe(function (result) {
                console.log(result);
            });
        }
    };
    /**
     * 课程作业点击事件
     * @param homework 当前作业对象
     */
    LearningPathComponent.prototype.homeworkCardClick = function (homework) {
        if (homework.homeworkExpiryAtFlag) {
            this.promptText = '作业已经过期了。';
            this.showToast();
        }
        else if (!homework.homeworkOpenAtFlag) {
            this.promptText = '该作业将于' + this.tansFromTimestamp(homework.homeworkOpenAt, 2) + '开放。';
            this.showToast();
        }
        else {
            if (homework.homeworkProgress === 100 || homework.homeworkCloseAtFlag) {
                if (homework.constituteId != null && homework.constituteId > 0) {
                    this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: 0, constituteId: homework.constituteId, courseLearningPathMetaId: this.learningPathMetaId, 'homeworkCloseAtFlag': homework.homeworkCloseAtFlag ? 1 : 0 } }).then();
                }
                else {
                    this.router.navigate(['home-work-show', homework['homeworkDuplicateId']], { queryParams: { 'learningPathMetaId': this.learningPathMetaId, 'tabNum': 0, 'homeworkCloseAtFlag': homework.homeworkCloseAtFlag ? 1 : 0 } }).then();
                }
            }
            else {
                if (homework.constituteId != null && homework.constituteId > 0) {
                    this.router.navigate(['exercise-work', homework['constituteId']], { queryParams: { courseLearningPathMetaId: this.learningPathMetaId } });
                }
                else {
                    this.router.navigate(['home-work', this.projectId, this.learningPathMetaId, homework['homeworkDuplicateId']]).then();
                }
            }
        }
    };
    /**
     * 获取当能力下的作业
     * @param projectId 项目id
     * @param learningPathMetaId 能力id
     */
    LearningPathComponent.prototype.getAbilityHomework = function (projectId, learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/homeworkList?projectId=' + projectId + '&learningPathMetaId=' + learningPathMetaId
        }).toPromise();
    };
    return LearningPathComponent;
}());
export { LearningPathComponent };



// WEBPACK FOOTER //
// ./src/app/learning-path/learning-path.component.ts.pre-build-optimizer.js